import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	registeringVolunteer: false,
	registerVolunteerError: null,
};

const slice = createSlice({
	name: "@volunteerRegistrations",
	initialState,
	reducers: {
		registerVolunteerBegin(state) {
			state.registeringVolunteer = true;
			state.registerVolunteerError = null;
		},
		registerVolunteerSuccess(state, action) {
			state.registeringVolunteer = false;
			state.registerVolunteerError = null;
		},
		registerVolunteerFailure(state, action) {
			state.registeringVolunteer = false;
			state.registerVolunteerError = action.payload;
		},
	},
});

export const { registerVolunteerBegin, registerVolunteerSuccess, registerVolunteerFailure } = slice.actions;

export default slice.reducer;
